import type { ColumnDef } from '@tanstack/react-table';
import type { ReportTransactionItem } from '@eriko/shared-types';
import { formatSignedCurrency } from '@eriko/shared-types';
import { cn } from '../lib/utils';

export const transactionColumns: ColumnDef<ReportTransactionItem>[] = [
  {
    accessorKey: 'date',
    header: 'Date',
    size: 90,
    cell: ({ getValue }) => (
      <span className="font-mono text-[12px] text-surface-600">{getValue<string>()}</span>
    ),
  },
  {
    accessorKey: 'description',
    header: 'Description',
    cell: ({ getValue }) => (
      <span className="text-[13px] font-medium text-surface-900 truncate block">
        {getValue<string>()}
      </span>
    ),
  },
  {
    accessorKey: 'category',
    header: 'Category',
    size: 140,
    cell: ({ getValue }) => (
      <span className="inline-flex px-2.5 py-0.5 rounded-md text-[11px] font-medium bg-surface-100 text-surface-800 border border-surface-300">
        {getValue<string>()}
      </span>
    ),
  },
  {
    accessorKey: 'amount',
    header: () => <span className="text-right block">Amount</span>,
    size: 110,
    cell: ({ getValue }) => {
      const amount = getValue<number>();
      return (
        <span
          className={cn(
            'font-mono text-[13px] font-medium text-right block',
            amount > 0 ? 'text-pos' : 'text-surface-700',
          )}
        >
          {formatSignedCurrency(amount)}
        </span>
      );
    },
  },
];
